<template>
  <div class="album-detail maxW" style="margin-top: 8%">
    <!-- <div class="album-nav-link">
      <router-link to="/home/map">成长地图</router-link>
      <strong>
        <i>></i>{{ '第' + (level + 1) + '关' }} {{ albumListData.map_lname }}
      </strong>
    </div> -->

    <nav-crumb :pathList="pathList" />

    <div class="album-window clear">
      <div class="album-window-r">
        <!-- <h2 class="albumb-w-h2">{{ albumData.name }}</h2> -->
        <h2 class="albumb-w-h2">
          {{ "第" + level + "关" }} {{ albumListData.map_lname }}
        </h2>
        <div class="keyword-tips">
          <el-tag v-for="item in albumData.keyword_arr" :key="item">{{
            item
          }}</el-tag>
        </div>
        <ul class="clear">
          <li class="albumb-class fl">
            <div>
              <span class="video-count">{{ videoCount }}</span>
              <span class="a-tit">{{ $t("homepage.course") }}</span>
            </div>
          </li>
          <li class="albumb-study-count clear">
            <div>
              <span class="user-count">{{ albumData.user_count }}</span>
              <span class="a-tit">{{ $t("homepage.learner") }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="album-introduction">
      <div class="album-nav-tabs">
        <span
          :class="[albumTab == 1 ? 'nav-tab is-active' : 'nav-tab']"
          :style="$i18n.locale === 'en-us' ? 'width: 200px' : 'width: 160px'"
          >目录</span
        >
      </div>
      <div class="tab-panes">
        <div class="tab-pane">
          <ul>
            <li
              class="album-ls2 clear"
              v-for="(item1, index1) of albumListData.child"
              :key="index1"
            >
              <div class="section-title" @click="foldSection(item1, index1)">
                <div class="section-left">{{ item1.map_lname }}</div>
                <div class="section-right" v-if="item1.video.length">
                  <i v-if="!item1.status" class="el-icon-arrow-down"></i>
                  <i v-else class="el-icon-arrow-right"></i>
                </div>
              </div>
              <template v-if="!item1.status">
                <div
                  class="video-content"
                  v-for="(video, q) of item1.video"
                  :key="video.res_id"
                  style="cursor: pointer"
                >
                  <div v-if="!video.label_video" class="no_label_video">
                    <div
                      class="video-title"
                      @click="goVideoDetails(video, video.res_id)"
                    >
                      <span style="padding-right: 20px">{{ q + 1 }}</span
                      >{{ video.name }}
                    </div>
                    <div class="red_dot" v-if="video.is_update" />

                    <div style="width: 60px">
                      <span style="padding-right: 3px"
                        >{{ $t("homepage.video") }}
                      </span>
                      <i
                        class="el-icon-success"
                        :style="{
                          color: video.is_video_complete ? '#67C23A' : '#ccc',
                        }"
                      >
                      </i>
                    </div>

                    <div
                      v-if="video.have_test"
                      :style="{
                        width: video.test_score ? '120px' : '60px',
                        display: 'flex',
                      }"
                    >
                      <span style="padding-right: 3px"
                        >{{ $t("homepage.test") }}
                      </span>

                      <i
                        class="el-icon-success"
                        :style="{
                          color: video.is_test_complete ? '#67C23A' : '#ccc',
                          margin: video.is_test_complete ? '0 5px' : '0',
                        }"
                      >
                      </i>
                      <span v-if="video.test_score" class="video_score"
                        >{{ video.test_score }}分</span
                      >
                    </div>
                  </div>

                  <div v-else style="width: 100%">
                    <div class="video_label" @click="foldSection(video, q)">
                      <div class="section-left">
                        <span style="padding-right: 20px"> {{ q + 1 }}</span>
                        {{ video.name }}
                      </div>
                      <div
                        class="section-right"
                        v-if="video.label_video.length"
                      >
                        <i v-if="video.status" class="el-icon-arrow-down"></i>
                        <i v-else class="el-icon-arrow-right"></i>
                      </div>
                    </div>

                    <template v-if="video.status">
                      <div
                        class="video-content"
                        v-for="(videoLabel, indexLabel) of video.label_video"
                        :key="videoLabel.res_id"
                        style="cursor: pointer; padding-left: 15px"
                      >
                        <div
                          class="video-title"
                          @click="goVideoDetails(videoLabel, videoLabel.res_id)"
                        >
                          <span style="padding-right: 20px">{{
                            indexLabel + 1
                          }}</span
                          >{{ videoLabel.name }}
                        </div>
                        <div class="red_dot" v-if="videoLabel.is_update" />

                        <div style="width: 60px">
                          <span style="padding-right: 3px"
                            >{{ $t("homepage.video") }}
                          </span>
                          <i
                            class="el-icon-success"
                            :style="{
                              color: videoLabel.is_video_complete
                                ? '#67C23A'
                                : '#ccc',
                            }"
                          >
                          </i>
                        </div>

                        <div
                          v-if="videoLabel.have_test"
                          :style="{
                            width: videoLabel.test_score ? '120px' : '60px',
                            display: 'flex',
                          }"
                        >
                          <span style="padding-right: 3px"
                            >{{ $t("homepage.test") }}
                          </span>

                          <i
                            class="el-icon-success"
                            :style="{
                              color: videoLabel.is_test_complete
                                ? '#67C23A'
                                : '#ccc',
                              margin: videoLabel.is_test_complete
                                ? '0 5px'
                                : '0',
                            }"
                          >
                          </i>

                          <span v-if="videoLabel.test_score" class="video_score"
                            >{{ videoLabel.test_score }}分</span
                          >
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navCrumb from "@/components/common/navCrumb.vue";

export default {
  data() {
    return {
      pathList: [{ path: "/home/map", name: "成长地图" }],
      level: this.$route.query.level,
      user_id: this.$g.user_id,
      mapId: this.$route.query.id,
      albumData: {
        keyword_arr: [],
      },
      is_fav: 0,
      albumTab: 1,
      albumListData: [],
      videoSign: "",
      videoCount:0,
    };
  },
  created() {
    this.getMap();
  },
  components: {
    navCrumb,
  },
  computed: {
    isTencentCloud() {
      return sessionStorage.getItem("tencentCloud") ? true : false;
    },
  },
  methods: {
    foldSection(item1, index1) {
      item1.status = !item1.status;
      let newVal = this.albumListData.child;
      this.albumListData.child = [];
      this.albumListData.child = newVal;
    },
    // 获取专辑数据：
    getMap() {
      let success = (res) => {
        this.albumData = res.data;
        res.data.maps_l.forEach((item) => {
          item.child.forEach((item1) => {
            item1.status = true;
          });
        });
        this.albumListData = res.data.maps_l[parseInt(this.level) - 1];
        this.videoCount=res.data.maps_l[parseInt(this.level) - 1].video_count
        this.pathList.push(
          {
            path: null,
            name: this.albumData.name,
          },
          {
            path: null,
            name: "第" + this.level + "关",
          }
        );
      };
      this.$ajax({
        url: "api/map/map",
        method: "get",
        params: {
          id: this.mapId, // 地图id
          user_id: this.user_id, // 当前登录人id
          view_type: 1, //1：前台展示，2：后台展示
        },
        func: {
          success: success,
        },
      });
    },
    goVideoDetails(item, resId) {
      // video_see_status
      if (item.video_see_status !== 3) {
        // let success = (res) => {
        //   if (res.data.islimit == 0) {
        //     this.$message.warning(this.$t("global.authorityMessage"));
        //   } else {
        this.$router.push({
          path: "/home/taskVideo",
          query: { id: resId, taskId: this.mapId, type: "map" },
        });
        // window.open(location.origin + '/home/taskVideo?id=' + resId + "&taskId=" + this.mapId + '&type=map');
        //   }
        // };
        // this.$ajax.get("/api/video/get_islimit_by_video_user_id", {
        //   params: {
        //     type: 0,//0：视频；1：试卷；2：资源
        //     type_id: resId,
        //     user_id: this.user_id,
        //   },
        //   func: { success },
        // });
      }else{
        this.$message.warning('暂未解锁');
      }
    },
    turnVideoDetails(id, url, type) {
      let success = (res) => {
        if (res.data.islimit == 0) {
          this.$message.closeAll();
          this.$message.warning(this.$t("global.authorityMessage"));
        } else {
          window.open(url);
        }
      };
      this.$ajax.get("/api/video/get_islimit_by_video_user_id", {
        params: {
          type: type,
          type_id: id,
          user_id: JSON.parse(sessionStorage.getItem("user_info_str"))
            ? JSON.parse(sessionStorage.getItem("user_info_str")).id
            : "",
        },
        func: { success },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.video-content {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #efefef;
  align-items: center;
  position: relative;

  .video-title {
    line-height: 48px;
    height: 48px;
    text-indent: 4rem;
    width: 100%;
  }

  .red_dot {
    width: 7px;
    height: 7px;
    background-color: red;
    border-radius: 30px;
    left: 35px;
    top: 10px;
    z-index: 99;
    position: absolute;
  }

  .video_type {
    width: 3rem;
  }
}

.section-title {
  text-indent: 2rem;
  cursor: pointer;
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  line-height: 48px;
  font-family: MicrosoftYaHei;
  height: 48px;
  background: #fef3f3;
  border-bottom: 1px solid #efefef;
  display: flex;
  justify-content: space-between;

  .section-right {
    margin-right: 1.5rem;
  }
}

.album-window {
  padding-bottom: 20px;
  margin-top: 2rem;

  .album-window-l {
    display: inline-block;
    width: 470px;
    height: 270px;
    background-color: #fff;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .album-window-r {
    display: inline-block;
    box-sizing: border-box;
    width: 100%;
    padding: 20px 30px 0;
    height: 270px;
    background-color: #fff;
    background-image: url("../../../assets/images/v2/album_bg.png");
    background-repeat: no-repeat;
    background-position: right;

    .albumb-w-h2 {
      font-size: 22px;
      font-weight: bold;
      line-height: 30px;
      height: 30px;
    }

    .keyword-tips {
      height: 30px;
      padding: 16px 0 22px;

      .el-tag {
        font-size: 14px;
        color: #3589b2;
        height: 30px;
        line-height: 30px;
        margin-right: 10px;
        background: #e1f3ff;
        border: 0 none;
      }
    }

    span {
      font-size: 14px;
    }

    .albumb-class,
    .albumb-study-count {
      padding: 8px 0;
      overflow: hidden;

      > div {
        border-left: 1px solid #d8d8d8;
        width: 100px;
        height: 40px;
        text-align: center;

        > span {
          display: block;
          color: #000;

          &:first-child {
            transform: translateY(-8px);
            height: 26px;
            line-height: 26px;
            font-size: 24px;
            word-spacing: 0.18px;
          }

          &:last-child {
            line-height: 20px;
            font-size: 14px;
            color: #666666;
            word-spacing: 0.11px;
          }
        }
      }
    }

    .albumb-study-count > div {
      border-right: 1px solid #d8d8d8;
    }

    .video-count {
      color: #db9c00;
    }

    .albumb-collect {
      height: 40px;
      line-height: 40px;

      .ipng {
        width: 25px;
        height: 40px;
        cursor: pointer;
      }

      .collect {
        background-position: -465px -768px;
      }

      .uncollect {
        background-position: -440px -768px;
      }
    }

    .albumb-share {
      margin-top: 40px;
      height: 20px;
      line-height: 20px;

      .a-tit {
        margin-right: 40px;
      }

      .share_ele {
        > div {
          line-height: 20px;

          > a {
            margin: 0;
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
}

.album-introduction {
  background-color: #fff;
  margin-bottom: 40px;

  .album-nav-tabs {
    border-bottom: 1px solid #efefef;

    .is-active {
      color: #e62125;
      position: relative;
      border-left: 1px solid #dddddd;
      border-right: 1px solid #dddddd;
    }

    .is-active::after {
      position: absolute;
      bottom: -2px;
      left: 0;
      content: "";
      width: 100%;
      height: 5px;
      background: #fff;
    }

    .nav-tab {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      cursor: pointer;

      &:first-child {
        border-left: 0 none;
      }
    }
  }

  .tab-pane {
    min-height: 300px;
    padding: 40px 40px 20px 45px;
  }

  .album-ul {
    .album-tit {
      font-size: 16px;
      line-height: 48px;
      font-weight: bold;
      height: 48px;
      background: #fef3f3;
      border-bottom: 1px solid #efefef;
    }

    .tit-num {
      display: inline-block;
      width: 100px;
      text-align: center;
    }

    .album-ls2 {
      font-size: 16px;
      font-weight: bold;

      .ls-content {
        position: relative;

        .profile {
          display: inline-block;
          vertical-align: top;
          max-width: 60%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        i {
          margin-right: 5px;
        }

        .album_btns {
          display: none;
          position: absolute;
          top: 0;
          right: 0;

          .el-button {
            width: 66px;
            height: 32px;
            padding: 0;
            font-size: 14px;
            background: #e62126;
            border: 0 none;
          }
        }
      }
    }

    .ls-content:hover > .album_btns {
      display: block;
    }

    .ls-content:hover > i {
      display: none;
    }

    .ls-content:hover > .album-ls2 {
      background-color: #effaff;
    }
  }

  .albumIntroduction {
    border-bottom: 1px dashed #e0e0e0;
    padding-bottom: 25px;
    margin-bottom: 30px;

    .albumIntroduction-r {
      margin-left: 100px;

      .about-teacher {
        display: inline-block;
        width: 100%;
        // height: 30px;
        line-height: 80px;
        font-size: 22px;
      }
    }
  }

  .album-outline,
  .album-appraise {
    .downBtn {
      margin-bottom: 20px;
    }
  }
}

.no_label_video {
  display: flex;
  width: 100%;
  align-items: center;
}

.video_label {
  text-indent: 4rem;
  cursor: pointer;
  width: 100%;
  line-height: 48px;
  font-family: MicrosoftYaHei;
  height: 48px;
  border-bottom: 1px solid #efefef;
  display: flex;
  justify-content: space-between;

  .section-right {
    margin-right: 1.5rem;
  }
}
</style>
